import {dayjs} from '../../../utils/dayjs-config';

export const getTenantWeekStart = (dateKey: string, timezone: string) =>
  dayjs.tz(dateKey, timezone).startOf('week');

export const moveTenantWeek = (dateKey: string, timezone: string, amount: number) =>
  getTenantWeekStart(dateKey, timezone).add(amount, 'week').format('YYYY-MM-DD');
